import { DecimalSchema } from "../../decimal";
import { BalancedRuleSimulationDataSchema, TradingCampaignRules } from "./trade-to-earn-rules";
import { z } from "zod";

const baseSchema = {
  records: z.array(
    z.object({
      id: z.number(),
      leaderboardId: z.number(),
      hubUserId: z.number(),
      rank: z.number(),
      volumeUSD: DecimalSchema,
      tradedVolumeUSD: DecimalSchema,
      rewardTokenAmount: DecimalSchema,
      rewardTokenSymbol: z.string(),
      rewardTokenAddress: z.string(),
      rewardClaimed: z.coerce.date().nullable(),
      tradesCount: z.number(),
      computedEvents: z.array(z.number()),
    }),
  ),
  simulationData: z.record(z.string(), z.any()),
};
export const SimulationLeaderboardResultDtoSchema = z.discriminatedUnion("rule", [
  z.object({ rule: z.literal(TradingCampaignRules.FIXED_PER_VOLUME), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PRIZE_BY_SLOT), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PROPORTIONAL), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PROPORTIONAL_V2), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.SPREAD_TRADES_OVER_TIME), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.CUSTOM), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PVP), ...baseSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.STAIRS), ...baseSchema }),
  z.object({
    rule: z.literal(TradingCampaignRules.GAUSSIAN),
    records: baseSchema.records,
    simulationData: BalancedRuleSimulationDataSchema,
  }),
  z.object({
    rule: z.literal(TradingCampaignRules.POWER),
    records: baseSchema.records,
    simulationData: BalancedRuleSimulationDataSchema,
  }),
]);

export type SimulationLeaderboardResultDtoType = z.infer<typeof SimulationLeaderboardResultDtoSchema>;
